/** @module api/log_events */

import { apiCall } from '@/api/index'
import { apiV1LogEventsPath } from '@/../lib/routes'

export function getLogEvents({ ctxt, dateTo, latestLogEventPerLogSource, period }) {
  const filter = {
    tFilter: {
      dateTo,
      period
    },
    latestLogEventPerLogSource
  }

  return apiCall({
    path: apiV1LogEventsPath(ctxt),
    payload: {
      filter
    }
  })
}
